import { Team } from '../../../../../../types/sport';
import { ESPN_HEROS_BASE_URL } from '../../urls';
import { ESPN_HERO_LIGUE1_PLAYER_IMAGES } from './ligue1-player-images';

const BASE_FACE_URL = `${ESPN_HEROS_BASE_URL}/ligue1`;

export const ESPN_HERO_LIGUE1_TEAMS: Team[] = [
  {
    value: 'angers',
    label: 'Angers',
    players: [
      {
        value: 'belkhdim-yassin',
        label: 'Belkhdim Yassin',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/angers/belkhdim-yassin/face/belkhdim-yassin.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.angers['belkhdim-yassin']
      },
      {
        value: 'cherif-sidiki',
        label: 'Cherif Sidiki',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/angers/cherif-sidiki/face/cherif-sidiki.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.angers['cherif-sidiki']
      },
      {
        value: 'himad-abdelli',
        label: 'Himad Abdelli',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/angers/himad-abdelli/face/himad-abdelli.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.angers['himad-abdelli']
      },
      {
        value: 'ousmane-camara',
        label: 'Ousmane Camara',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/angers/ousmane-camara/face/ousmane-camara.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.angers['ousmane-camara']
      }
    ]
  },
  {
    value: 'as-monaco',
    label: 'AS Mónaco',
    players: [
      {
        value: 'ansu-fati',
        label: 'Ansu Fati',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/ansu-fati/face/ansu-fati.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['ansu-fati']
      },
      {
        value: 'denis-zakaria',
        label: 'Denis Zakaria',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/denis-zakaria/face/denis-zakaria.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['denis-zakaria']
      },
      {
        value: 'folarin-balogun',
        label: 'Folarin Balogun',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/folarin-balogun/face/folarin-balogun.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['folarin-balogun']
      },
      {
        value: 'golovin-aleksandr',
        label: 'Golovin Aleksandr',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/golovin-aleksandr/face/golovin-aleksandr.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['golovin-aleksandr']
      },
      {
        value: 'minamino-takumi',
        label: 'Minamino Takumi',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/minamino-takumi/face/minamino-takumi.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['minamino-takumi']
      },
      {
        value: 'paul-pogba',
        label: 'Paul Pogba',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/as-monaco/paul-pogba/face/paul-pogba.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['as-monaco']['paul-pogba']
      }
    ]
  },
  {
    value: 'auxerre',
    label: 'Auxerre',
    players: [
      {
        value: 'danny-namaso',
        label: 'Danny Namaso',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/auxerre/danny-namaso/face/danny-namaso.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.auxerre['danny-namaso']
      },
      {
        value: 'diomande-sinaly',
        label: 'Diomande Sinaly',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/auxerre/diomande-sinaly/face/diomande-sinaly.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.auxerre['diomande-sinaly']
      },
      {
        value: 'francisco-sierralta',
        label: 'Francisco Sierralta',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/auxerre/francisco-sierralta/face/francisco-sierralta.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.auxerre['francisco-sierralta']
      },
      {
        value: 'lassine-sinayoko',
        label: 'Lassine Sinayoko',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/auxerre/lassine-sinayoko/face/lassine-sinayoko.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.auxerre['lassine-sinayoko']
      }
    ]
  },
  {
    value: 'brest',
    label: 'Brest',
    players: [
      {
        value: 'kamory-doumbia',
        label: 'Kamory Doumbia',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/brest/kamory-doumbia/face/kamory-doumbia.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.brest['kamory-doumbia']
      },
      {
        value: 'lala-kenny',
        label: 'Lala Kenny',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/brest/lala-kenny/face/lala-kenny.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.brest['lala-kenny']
      },
      {
        value: 'romain-del-castillo',
        label: 'Romain Del Castillo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/brest/romain-del-castillo/face/romain-del-castillo.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.brest['romain-del-castillo']
      }
    ]
  },
  {
    value: 'le-havre',
    label: 'Le Havre AC',
    players: [
      {
        value: 'issa-soumare',
        label: 'Issa Soumare',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/le-havre/issa-soumare/face/issa-soumare.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['le-havre']['issa-soumare']
      },
      {
        value: 'rassoul-ndiaye',
        label: 'Rassoul Ndiaye',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/le-havre/rassoul-ndiaye/face/rassoul-ndiaye.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['le-havre']['rassoul-ndiaye']
      },
      {
        value: 'yassine-ketcha',
        label: 'Yassine Ketcha',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/le-havre/yassine-ketcha/face/yassine-ketcha.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['le-havre']['yassine-ketcha']
      }
    ]
  },
  {
    value: 'lens',
    label: 'RC Lens',
    players: [
      {
        value: 'deiver-machado',
        label: 'Deiver Machado',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lens/deiver-machado/face/deiver-machado.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lens['deiver-machado']
      },
      {
        value: 'malang-sarr',
        label: 'Malang Sarr',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lens/malang-sarr/face/malang-sarr.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lens['malang-sarr']
      },
      {
        value: 'mamadou-sangare',
        label: 'Mamadou Sangare',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lens/mamadou-sangare/face/mamadou-sangare.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lens['mamadou-sangare']
      },
      {
        value: 'odsonne-edouard',
        label: 'Odsonne Edouard',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lens/odsonne-edouard/face/odsonne-edouard.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lens['odsonne-edouard']
      },
      {
        value: 'thauvin',
        label: 'Thauvin',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lens/thauvin/face/thauvin.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lens['thauvin']
      }
    ]
  },
  {
    value: 'lille',
    label: 'Lille',
    players: [
      {
        value: 'bentaleb',
        label: 'Bentaleb',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lille/bentaleb/face/bentaleb.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lille['bentaleb']
      },
      {
        value: 'ethan-mbappe',
        label: 'Ethan Mbappe',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lille/ethan-mbappe/face/ethan-mbappe.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lille['ethan-mbappe']
      },
      {
        value: 'giroud',
        label: 'Giroud',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lille/giroud/face/giroud.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lille['giroud']
      },
      {
        value: 'hakon-haraldsson',
        label: 'Hakon Haraldsson',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lille/hakon-haraldsson/face/hakon-haraldsson.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lille['hakon-haraldsson']
      },
      {
        value: 'meunier',
        label: 'Meunier',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lille/meunier/face/meunier.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lille['meunier']
      }
    ]
  },
  {
    value: 'lorient',
    label: 'FC Lorient',
    players: [
      {
        value: 'aiyegun-tosin',
        label: 'Aiyegun Tosin',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lorient/aiyegun-tosin/face/aiyegun-tosin.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lorient['aiyegun-tosin']
      },
      {
        value: 'igor-silva',
        label: 'Igor Silva',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lorient/igor-silva/face/igor-silva.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lorient['igor-silva']
      },
      {
        value: 'pablo-pagis',
        label: 'Pablo Pagis',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lorient/pablo-pagis/face/pablo-pagis.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lorient['pablo-pagis']
      },
      {
        value: 'sambou-soumano',
        label: 'Sambou Soumano',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lorient/sambou-soumano/face/sambou-soumano.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lorient['sambou-soumano']
      }
    ]
  },
  {
    value: 'lyon',
    label: 'Lyon',
    players: [
      {
        value: 'fofana',
        label: 'Fofana',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lyon/fofana/face/fofana.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lyon['fofana']
      },
      {
        value: 'ghezzal',
        label: 'Ghezzal',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lyon/ghezzal/face/ghezzal.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lyon['ghezzal']
      },
      {
        value: 'tagliafico',
        label: 'Tagliafico',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lyon/tagliafico/face/tagliafico.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lyon['tagliafico']
      },
      {
        value: 'tolisso',
        label: 'Tolisso',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/lyon/tolisso/face/tolisso.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.lyon['tolisso']
      }
    ]
  },
  {
    value: 'metz',
    label: 'FC Metz',
    players: [
      {
        value: 'cheikh-sabaly',
        label: 'Cheikh Sabaly',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/metz/cheikh-sabaly/face/cheikh-sabaly.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.metz['cheikh-sabaly']
      },
      {
        value: 'gauthier-hein',
        label: 'Gauthier Hein',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/metz/gauthier-hein/face/gauthier-hein.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.metz['gauthier-hein']
      },
      {
        value: 'giorgi-tsitaishvili',
        label: 'Giorgi Tsitaishvili',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/metz/giorgi-tsitaishvili/face/giorgi-tsitaishvili.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.metz['giorgi-tsitaishvili']
      },
      {
        value: 'habib-diallo',
        label: 'Habib Diallo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/metz/habib-diallo/face/habib-diallo.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.metz['habib-diallo']
      }
    ]
  },
  {
    value: 'nantes',
    label: 'FC Nantes',
    players: [
      {
        value: 'johann-lepenant',
        label: 'Johann Lepenant',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/nantes/johann-lepenant/face/johann-lepenant.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.nantes['johann-lepenant']
      },
      {
        value: 'matthis-abline',
        label: 'Matthis Abline',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/nantes/matthis-abline/face/matthis-abline.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.nantes['matthis-abline']
      },
      {
        value: 'mostafa-abdalla',
        label: 'Mostafa Abdalla',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/nantes/mostafa-abdalla/face/mostafa-abdalla.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.nantes['mostafa-abdalla']
      }
    ]
  },
  {
    value: 'niza',
    label: 'Niza',
    players: [
      {
        value: 'costa-santos-dante',
        label: 'Costa Santos Dante',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/niza/costa-santos-dante/face/costa-santos-dante.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.niza['costa-santos-dante']
      },
      {
        value: 'jeremie-boga',
        label: 'Jeremie Boga',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/niza/jeremie-boga/face/jeremie-boga.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.niza['jeremie-boga']
      },
      {
        value: 'jonathan-clauss',
        label: 'Jonathan Clauss',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/niza/jonathan-clauss/face/jonathan-clauss.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.niza['jonathan-clauss']
      },
      {
        value: 'morgan-sanson',
        label: 'Morgan Sanson',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/niza/morgan-sanson/face/morgan-sanson.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.niza['morgan-sanson']
      },
      {
        value: 'sofiane-diop',
        label: 'Sofiane Diop',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/niza/sofiane-diop/face/sofiane-diop.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.niza['sofiane-diop']
      }
    ]
  },
  {
    value: 'o-marseille',
    label: 'Marseille',
    players: [
      {
        value: 'aubameyang',
        label: 'Aubameyang',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/aubameyang/face/aubameyang.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['aubameyang']
      },
      {
        value: 'balerdi',
        label: 'Balerdi',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/balerdi/face/balerdi.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['balerdi']
      },
      {
        value: 'hojbjerg',
        label: 'Hojbjerg',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/hojbjerg/face/hojbjerg.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['hojbjerg']
      },
      {
        value: 'medina',
        label: 'Medina',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/medina/face/medina.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['medina']
      },
      {
        value: 'paixao',
        label: 'Paixao',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/paixao/face/paixao.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['paixao']
      },
      {
        value: 'weah',
        label: 'Weah',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/o-marseille/weah/face/weah.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['o-marseille']['weah']
      }
    ]
  },
  {
    value: 'paris-fc',
    label: 'Paris FC',
    players: [
      {
        value: 'ilan-kebbal',
        label: 'Ilan Kebbal',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/paris-fc/ilan-kebbal/face/ilan-kebbal.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['paris-fc']['ilan-kebbal']
      },
      {
        value: 'moses-simon',
        label: 'Moses Simon',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/paris-fc/moses-simon/face/moses-simon.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['paris-fc']['moses-simon']
      },
      {
        value: 'otavio-da-silva',
        label: 'Otavio Da Silva',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/paris-fc/otavio-da-silva/face/otavio-da-silva.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES['paris-fc']['otavio-da-silva']
      }
    ]
  },
  {
    value: 'psg',
    label: 'PSG',
    players: [
      {
        value: 'barcola',
        label: 'Barcola',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/barcola/face/barcola.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['barcola']
      },
      {
        value: 'dembele',
        label: 'Dembele',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/dembele/face/dembele.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['dembele']
      },
      {
        value: 'kvaratskhelia',
        label: 'Kvaratskhelia',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/kvaratskhelia/face/kvaratskhelia.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['kvaratskhelia']
      },
      {
        value: 'marquinhos',
        label: 'Marquinhos',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/marquinhos/face/marquinhos.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['marquinhos']
      },
      {
        value: 'pacho',
        label: 'Pacho',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/pacho/face/pacho.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['pacho']
      },
      {
        value: 'vitinha',
        label: 'Vitinha',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/psg/vitinha/face/vitinha.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.psg['vitinha']
      }
    ]
  },
  {
    value: 'rennes',
    label: 'Rennes',
    players: [
      {
        value: 'blas-ludovic',
        label: 'Blas Ludovic',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rennes/blas-ludovic/face/blas-ludovic.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.rennes['blas-ludovic']
      },
      {
        value: 'breel-embolo',
        label: 'Breel Embolo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rennes/breel-embolo/face/breel-embolo.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.rennes['breel-embolo']
      },
      {
        value: 'lepaul',
        label: 'Lepaul',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rennes/lepaul/face/lepaul.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.rennes['lepaul']
      },
      {
        value: 'seko-fofana',
        label: 'Seko Fofana',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rennes/seko-fofana/face/seko-fofana.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.rennes['seko-fofana']
      }
    ]
  },
  {
    value: 'strasbourg',
    label: 'Strasbourg',
    players: [
      {
        value: 'barco',
        label: 'Barco',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/strasbourg/barco/face/barco.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.strasbourg['barco']
      },
      {
        value: 'enciso',
        label: 'Enciso',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/strasbourg/enciso/face/enciso.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.strasbourg['enciso']
      },
      {
        value: 'panichelli',
        label: 'Panichelli',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/strasbourg/panichelli/face/panichelli.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.strasbourg['panichelli']
      }
    ]
  },
  {
    value: 'toulouse',
    label: 'Toulouse',
    players: [
      {
        value: 'cristian-casseres',
        label: 'Cristian Casseres',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/toulouse/cristian-casseres/face/cristian-casseres.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.toulouse['cristian-casseres']
      },
      {
        value: 'emerson-da-silva',
        label: 'Emerson Da Silva',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/toulouse/emerson-da-silva/face/emerson-da-silva.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.toulouse['emerson-da-silva']
      },
      {
        value: 'frank-magri',
        label: 'Frank Magri',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/toulouse/frank-magri/face/frank-magri.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.toulouse['frank-magri']
      },
      {
        value: 'julian-vignolo',
        label: 'Julian Vignolo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/toulouse/julian-vignolo/face/julian-vignolo.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.toulouse['julian-vignolo']
      },
      {
        value: 'santiago-hidalgo',
        label: 'Santiago Hidalgo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/toulouse/santiago-hidalgo/face/santiago-hidalgo.png`,
        images: ESPN_HERO_LIGUE1_PLAYER_IMAGES.toulouse['santiago-hidalgo']
      }
    ]
  }
];
